import { render, staticRenderFns } from "./AccrualsRulesBuilder.vue?vue&type=template&id=2541e4dc&scoped=true"
import script from "./AccrualsRulesBuilder.vue?vue&type=script&lang=js"
export * from "./AccrualsRulesBuilder.vue?vue&type=script&lang=js"
import style0 from "./AccrualsRulesBuilder.vue?vue&type=style&index=0&id=2541e4dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2541e4dc",
  null
  
)

export default component.exports